module.exports = __webpack_public_path__ + "img/test_four1.fd51ebbd.png";